module.exports = __webpack_public_path__ + "static/polar-background-0d4c880f54c9fc62b7ef778fde4aaf63.png";